/* import __COLOCATED_TEMPLATE__ from './eisa-scoring-race-table.hbs'; */
import Component from '@glimmer/component';

export default class EisaScoringRaceTableComponent extends Component
{
	get teamScoresSorted()
	{
		const teamScores = this.args.race?.teamScores || {};
		return Object.entries(teamScores)
			.map(([team, score]) => ({ team, score }))
			.sort((a, b) => b.score - a.score);
	}

	get teamScorers()
	{
		return this.args.race?.teamScorers || {};
	}
}
